module.exports = __webpack_public_path__ + "img/blue_glitter.9f762300.jpg";